import type { AxiosResponse } from 'axios';

import axiosInstance from '../../instance';
import ROUTES from '../../routes';
import type { ISettings } from './types';

export const get = (): Promise<void | AxiosResponse<ISettings>> => axiosInstance({
  url: ROUTES.SETTINGS,
  method: 'GET',
  headers: {
    authorization: true,
  },
});

export const update = (data: ISettings): Promise<void | AxiosResponse<{ result: 0 }>> => axiosInstance({
  url: `${ROUTES.SETTINGS}`,
  method: 'PATCH',
  headers: {
    authorization: true,
  },
  data,
});
